export default (text: string): string => {
  return text.trim()
}
